import type { SaveStatus } from "@workspace/collaboration/types";

export type StatusKind = "saved" | "unsaved" | "saving" | "offline" | "failed";

/**
 * Resolve the browser's connectivity and the collab session's save status into
 * the single state the indicator shows.
 *
 * Precedence is deliberate:
 *  - `failed` outranks everything. The server rejected the session, so the
 *    edits are local-only and no amount of network will fix it silently.
 *  - connectivity outranks `saving`: a save that started before the network
 *    dropped would otherwise pulse forever with no chance of completing.
 */
export function resolveStatus(
  saveStatus: SaveStatus,
  online: boolean
): StatusKind {
  if (saveStatus === "failed") return "failed";
  if (!online || saveStatus === "offline") return "offline";
  if (saveStatus === "saved" || saveStatus === "persisted") return "saved";
  if (saveStatus === "saving") return "saving";
  return "unsaved";
}
